
















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import { Meta } from '@/decorators';
import store from '@/store';
import EventBus from '@/plugins/event-bus';

import { IAboutSection } from '@/store/modules/about/types/IAboutSection';
import IAboutMeta from '@/store/modules/about/types/IAboutMeta';
import IAboutHeader from '@/store/modules/about/types/IAboutHeader';

import BackgroundImage from '@/components/ui/BackgroundImage.vue';
import AboutSection from '@/components/blocks/about/AboutSection.vue';

async function dataHook(to: Route, from: Route, next: (callback?: any) => void) {
  try {
    await store.dispatch('about/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    BackgroundImage,
    AboutSection,
  },
})
export default class About extends Vue {
  private get meta(): IAboutMeta {
    return this.$store.state.about.meta;
  }

  private get header(): IAboutHeader {
    return this.$store.state.about.header;
  }

  private get sections(): IAboutSection[] {
    return this.$store.state.about.sections;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
       meta: [{
        vmid: 'description',
        name: 'description',
        content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
